import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import SolarGikDropdown, { MenuItem } from "../../SolarGikLib/fields/Dropdown";
import getIcons from "../../SolarGikLib/icons/Icons";
import { FieldIcons, IconCategory } from "../../SolarGikLib/icons/IconsModels";
import { RootState } from "../app/Store";
import SiteNameComponent from "../siteName/SiteNameComponent";
import { selectSiteId } from "../sites/SiteStore";
import { useSiteGroups } from "../site_groups/useSiteGroups";
import type { SiteGroupNavigation } from "./Layout";
import SiteGroupSwitcher from "./SiteGroupSwitcher";
import classes from "./SiteGroupSwitcher.module.css";
import { siteGroupPath } from "../site_groups/SiteGroupRoutes";

const ArrowDown = getIcons(FieldIcons.ArrowDown, IconCategory.Fields);
const WhiteArrow = () => <ArrowDown fill={"white"} style={{ flexShrink: 0 }} />;

const SwitchSiteComponent = ({ siteGroup }: { siteGroup?: SiteGroupNavigation }) => {
  const { sites: siteGroups } = useSiteGroups();
  const navigate = useNavigate();
  const location = useLocation();

  const multiSitesMetadata = useSelector((state: RootState) => state.multiSitesMetadata);

  const onSiteNameSubmitHandler = (siteId: string) => {
    const currentPathName = siteGroup ? "Home" : location.pathname.split("/").slice(2).join("/");
    const siteCode = multiSitesMetadata.sites[siteId].siteCode;
    if (siteCode) {
      navigate(`/${siteCode}/${currentPathName}`);
    }
  };

  const sitesIds = useSelector((state: RootState) => state.user.siteIds);
  const currentSiteId = useSelector(selectSiteId);

  const menuItems: MenuItem[] = sitesIds.map((siteId) => {
    return {
      label: <SiteNameComponent siteId={siteId} />,
      onClick: () => onSiteNameSubmitHandler(siteId),
      disabled: !siteGroup && siteId == currentSiteId,
    };
  });

  menuItems.push(
    ...siteGroups.map((site) => ({
      label: site.name,
      disabled: site.id === siteGroup?.id,
      onClick: () => navigate(siteGroupPath(site)),
    }))
  );

  return (
    <div className={classes.selectors}>
      <div className={classes.allSites}>
        {menuItems && (
          <SolarGikDropdown
            icon={WhiteArrow}
            menuItems={menuItems}
            buttonTooltip="Switch site"
            menuHeader="All Sites"
            title={
              siteGroup ? (
                <span className={classes.groupName}>{siteGroup.name}</span>
              ) : (
                <SiteNameComponent
                  siteId={currentSiteId}
                  asTitle={true}
                  wrapperStyle={{ minWidth: 0, flex: "1 1 auto", overflow: "hidden" }}
                />
              )
            }
            buttonCustomUi={{
              "&.MuiIconButton-root": {
                color: "white",
                maxWidth: "100%",
                "& > div > div": { minWidth: 0, width: "100%" },
                "& > svg": { flexShrink: 0 },
                minWidth: 0,
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "var(--header-and-nav-hover-color)",
                },
              },
            }}
            menuCustomUi={{
              "& .MuiPaper-root": {
                borderRadius: "12px",
              },
            }}
            menuItemCustomUi={{
              "&.MuiMenuItem-root:hover": {
                backgroundColor: "#EDEDED",
              },
            }}
          />
        )}
      </div>
      <SiteGroupSwitcher groups={siteGroups} siteId={currentSiteId} dashboardGroupId={siteGroup?.id} />
    </div>
  );
};
export default SwitchSiteComponent;
